import { useEffect, useState } from "react";

function diff(target) {
  const ms = Math.max(0, target - Date.now());
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const mins = Math.floor((ms / (1000 * 60)) % 60);
  const secs = Math.floor((ms / 1000) % 60);
  return { days, hours, mins, secs, done: ms === 0 };
}

const Cell = ({ value, label }) => (
  <div
    className="flex flex-col items-center"
    data-testid={`countdown-${label.toLowerCase()}`}
  >
    <span className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#0E0E0E] leading-none tabular-nums">
      {String(value).padStart(2, "0")}
    </span>
    <span className="font-mono text-[10px] sm:text-[11px] tracking-[0.22em] mt-2 text-[#0E0E0E]/70">
      {label}
    </span>
  </div>
);

export const CampCountdown = ({ targetISO, dateLabel, className = "" }) => {
  const target = new Date(targetISO).getTime();
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    setT(diff(target));
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <div
      data-testid="camp-countdown"
      className={`panel-flat bg-[#FFD700] border-2 border-[#0E0E0E] p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p className="font-mono text-[10px] sm:text-[11px] tracking-[0.22em] text-[#0E0E0E]">
            / NEXT CAMP · {dateLabel || "MAY 21"}
          </p>
          <p className="font-display text-xl sm:text-2xl text-[#0E0E0E] mt-1">
            {t.done ? "WE'RE LIVE." : "TIP-OFF IN"}
          </p>
        </div>
        <div className="flex items-end gap-3 sm:gap-5">
          <Cell value={t.days} label="DAYS" />
          <span className="font-display text-4xl text-[#0E0E0E]/40 leading-none pb-5">
            :
          </span>
          <Cell value={t.hours} label="HRS" />
          <span className="font-display text-4xl text-[#0E0E0E]/40 leading-none pb-5">
            :
          </span>
          <Cell value={t.mins} label="MIN" />
          <span className="font-display text-4xl text-[#0E0E0E]/40 leading-none pb-5">
            :
          </span>
          <Cell value={t.secs} label="SEC" />
        </div>
      </div>
    </div>
  );
};

export default CampCountdown;
